import { use, useEffect, useState } from "react";
import { TM } from "@litres-libs/tracker-manager";

import { getConfig } from "lib/get-config";
import { useTranslation } from "lib/i18n/use-translation";
import { NavigationContext } from "lib/navigation/use-navigation";
import { Button } from "lib/ui/button";
import { getBuyUrl } from "lib/urls/buy";

import IconClose from "assets/icons/close24.svg?react";
import css from "./fragment-finish.module.scss";

export function FragmentFinish() {
  const [dismissedPage, setDismissedPage] = useState<number | null>(null);

  const { page, totalPages } = use(NavigationContext)!;
  const { trials, art, texttrialbutton, price } = getConfig();
  const { t } = useTranslation();

  const isFragment = trials === 1;
  const isLastPage = totalPages > 0 && page === totalPages - 1;
  const shouldShow = isFragment && isLastPage;

  const isDismissed = dismissedPage === page;
  const isVisible = shouldShow && !isDismissed;

  const buyUrl = getBuyUrl();
  const coverUrl = `${import.meta.env.VITE_LITRES_CDN_URL}/pub/c/cover_415/${art}.jpg`;

  useEffect(() => {
    if (isVisible) {
      TM.sendEvent(["LITRES_TRACKER"], {
        eventType: "reader_fragment_popup_view",
        params: { book_id: art },
      });
    }
  }, [isVisible, art]);

  function handleDismiss() {
    TM.sendEvent(["LITRES_TRACKER"], {
      eventType: "reader_fragment_popup_click",
      params: { book_id: art, type: "close" },
    });

    setDismissedPage(page);
  }

  function handleBuyClick() {
    TM.sendEvent(["LITRES_TRACKER"], {
      eventType: "reader_fragment_popup_click",
      params: { book_id: art, type: "buy" },
    });

    window.location.href = buyUrl;
  }

  if (!isVisible) return null;

  return (
    <div className={css.overlay} onClick={handleDismiss}>
      <div className={css.modal} onClick={e => e.stopPropagation()}>
        <button className={css.close} onClick={handleDismiss}>
          <IconClose className={css.icon} />
        </button>
        <div className={css.content}>
          <img src={coverUrl} alt="" className={css.cover} />
          <h2 className={css.title}>{t("Вы прочли фрагмент")}</h2>
          <p className={css.subtitle}>
            {t("Получите полный доступ к книге, чтобы продолжить чтение")}
          </p>
          <Button onClick={handleBuyClick}>
            {price
              ? t("Купить за {{price}} ₽", { price })
              : (texttrialbutton ?? "")}
          </Button>
        </div>
      </div>
    </div>
  );
}
